import { formatCurrency } from "../../helpers/currencyUtil";
import DateUtils from "../../helpers/dateUtils";

const dateUtils = new DateUtils();

export const policyColumns = [
  {
    accessorKey: "submission_number",
    header: "Submission Number",
    cell: ({ getValue, row }) => {
      const submissionNumber = getValue();
      return submissionNumber ? (
        <a
          href={`https://app.coverwhale.com/transportation/${submissionNumber}/0`}
          target="_blank"
          rel="noreferrer"
          className="text-blue-600 underline"
        >
          {submissionNumber}
        </a>
      ) : (
        "N/A"
      );
    },
  },
  {
    accessorKey: "Company",
    header: "Company",
  },
  {
    accessorKey: "Agency Name",
    header: "Agency Name",
    cell: ({ getValue, row }) => {
      const agencyName = getValue();
      const accountId = row.original.account_id;
      
      return agencyName && agencyName !== "N/A" ? (
        <a
          href={
            window.location.host === "localhost:5002"
              ? `http://localhost:5002/admin/agency/${accountId}`
              : `https://admin.coverbadger.com/admin/agency/${accountId}`
          }
          target="_blank"
          rel="noreferrer"
          className="text-blue-600 underline"
        >
          {agencyName}
        </a>
      ) : (
        "N/A"
      );
    },
  },
  {
    accessorKey: "carrier",
    header: "Carrier",
  },
  {
    accessorKey: "Premium Amount",
    header: "Premium Amount",
  },
  {
    accessorKey: "effective_date",
    header: "Effective Date",
    cell: ({ getValue }) => {
      const date = getValue();
      return date ? dateUtils.formatIsoToCommomDate(date) : "N/A";
    },
  },
  {
    accessorKey: "Date submitted",
    header: "Date Submitted",
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ getValue }) => {
      const status = getValue();
      let badgeColor = "bg-gray-500";
      
      switch (status) {
        case "active":
          badgeColor = "bg-green-500";
          break;
        case "pending cancellation":
          badgeColor = "bg-orange-500";
          break;
        case "rejected":
          badgeColor = "bg-red-500";
          break;
        case "canceled":
          badgeColor = "bg-gray-500";
          break;
        default:
          badgeColor = "bg-gray-500";
      }
      
      return (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-white ${badgeColor}`}>
          {status}
        </span>
      );
    },
  },
]; 